export default __webpack_public_path__ + "static/media/17.2fab4b02.png";